import React, { MouseEvent } from 'react';
import styled from 'styled-components';

import { ModalContainer, ModalContent, ModalHeader, ModalSubtitle, ModalTitle, Overlay } from './CommonModal';
import { BackArrowContainer } from '../../pages/InvitePage';
import BackArrow from '../icons/BackArrow';
import { ButtonInternal } from '../buttons/SystemButton';
import { WideOutlineButton } from '../buttons/OutlineButton';
import { WideWhiteButton } from '../buttons/WhiteButton';

const SendUpdateNotificationModal = ({ close, confirm }: {
  close: () => void,
  confirm: (sendNotification: boolean) => void
}) => {
  const onModalClick = (e: MouseEvent) => {
    e.stopPropagation();
  };

  return <Overlay onMouseDown={close}>
    <ModalContainer onMouseDown={onModalClick}>
      <ModalContent>
        <ModalHeader>
          <BackArrowContainer onClick={close}>
            <BackArrow/>
          </BackArrowContainer>
          <ModalTitle>Send edit notification</ModalTitle>
        </ModalHeader>
        <ModalSubtitle>Do you want Shine Parties to send a notification to RSVPed users about the change you just
          made?</ModalSubtitle>
      </ModalContent>

      <Footer>
        <WideOutlineButton onClick={() => confirm(false)}>No</WideOutlineButton>
        <WideWhiteButton $invert={true} onClick={() => confirm(true)}>Yes</WideWhiteButton>
      </Footer>
    </ModalContainer>
  </Overlay>;
};

const Footer = styled.div`
  display: flex;
  gap: 20px;

  ${ButtonInternal} {
    width: 100%;
  }
`;

export default SendUpdateNotificationModal;

